<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
          [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
          (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)"
          (buttonClick)="navigateToNewParte()" [isPartesSection]="true" [buttonTitle]="buttonTitle" [disableOptions]="disableOptions" [disableNoAdmin]="disableNoAdmin"
          (deleteClick)="openDeleteModal($event)" (editParteClick)="navigateToEditParte($event)"
          (representantesClick)="navigateToRepresentantes($event)">
        </app-advanced-table>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>
      </div>
    </div>
  </div>
</div>

<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar la parte</span> "{{ parteToDelete?.razon_social }}"?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
